import React, { useMemo, useRef, useState } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  Paper,
  Backdrop,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect } from 'react';
import { Accessibility, AddBox, DirectionsRun } from '@mui/icons-material';
import { API, graphqlOperation } from 'aws-amplify';
import { deleteNumberTrackerAuto, deleteNumberTrackerByType, updateNumberTracker } from '../../../graphql';
import { useDispatch, useSelector } from 'react-redux';
import { createNumberTracker, listGeneralSetting } from '../../../graphql';
import { addNewSetting, heading } from './newVoucherSettingData';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import DeleteModal from '../../../components/modals/DeleteModal';
import ListingActive from '../../../components/modals/ListingActive';
import { VoucherSettingsApi } from '../../../redux/apis/newVoucherSettings.api';
import useSaveModalShortcut from '../Components/useSaveModalShortcut';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // bgcolor: "background.paper",
  boxShadow: 24,
  outline: 'none',
  // minWidth: { xs: "90%", md: "800px" },
  width: { xs: '90%', md: '820px' },
  // "&::-webkit-scrollbar": {
  //   width: "20px", // controls width
  // },
  // "&::-webkit-scrollbar-thumb": {
  //   backgroundColor: "#888", // color of the scrollbar
  //   borderRadius: "4px",
  // },
  // "&::-webkit-scrollbar-thumb:hover": {
  //   backgroundColor: "#555", // hover color
  // },
};

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const NewVoucherSettingsModal = ({ open, setOpen, label, type, onChange = () => {} }) => {
  const dispatch = useDispatch();

  const invalidateAllVoucherSerialNumbers = () => {
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'VoucherSerialNumbers', id: 'ALL' }]));
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listGeneralSettings', id: 'ALL' }]));
  };

  const [setting, setSetting] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modeModal, setModeModal] = useState({ type: false, val: '' });
  const [activeValueModal, setActiveValueModal] = useState(false);
  const [editData, setEditData] = useState('');
  const [settingObj, setSettingObj] = useState(addNewSetting);
  const [mode, setMode] = useState('');
  const [newSetting, setNewSetting] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const prefixref = useRef(null);
  const editDoneRef = useRef(null);
  const handleClose = () => {
    setOpen(false);
    setEditData('');
    setNewSetting(false);
    setSettingObj(addNewSetting);
  };
  console.log(newSetting, 'newSetting');
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let fyid = userPreferece?.financialYear?.financialyearid;
  console.log(fyid, 'fyiddd');
  useEffect(() => {
    if ((editData.id || newSetting) && prefixref.current) {
      prefixref.current.focus(); // Focus on the input field
    }
  }, [newSetting, editData.id]);
  const listSetting = async () => {
    setBackdropOpen(true);
    const res2 = await API.graphql(
      graphqlOperation(listGeneralSetting, {
        entrytypecd: type,
        financialyearid: fyid,
      })
    );
    console.log(res2, 'res222');
    // invalidateAllVoucherSerialNumbers();
    setSetting(res2.data.listGeneralSetting.filter((ar) => ar.nextinvoicenumber !== -1));
    const check = res2.data.listGeneralSetting.filter((ar) => ar.nextinvoicenumber === -1 && ar.expiredtimestamp === 0);
    if (check && check?.length > 0) {
      setMode('MANUAL');
    } else {
      setMode('AUTO');
    }
    setBackdropOpen(false);
  };
  useEffect(() => {
    if (open === true) {
      listSetting();
      console.log(open, 'open');
    }
  }, [open]);
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);

  const handleDelete = async (id) => {
    setBackdropOpen(true);
    const salesSettingsData = {
      id: Number(id),
    };

    const resSalesSettings = await API.graphql(
      graphqlOperation(deleteNumberTrackerAuto, {
        deleteNumberTrackerAutoByTypeInput: salesSettingsData,
      })
    );
    showSuccessSnackbar('Setting deleted');
    invalidateAllVoucherSerialNumbers();
    const newList = setting.filter((set) => set.id !== id);
    setSetting(newList);
    setBackdropOpen(false);
  };
  console.log(setting, 'setting');
  const INVOICE_REGEX = /^[A-Za-z1-9][A-Za-z0-9/-]*$/;
  const INVOICE_REGEX1 = /^[A-Za-z0-9/-]*$/;

  // Validation function for prefix
  const validatePrefix = (value) => {
    if (value === '') return true; // Allow empty prefix
    if (value.startsWith('0') || value.startsWith('/') || value.startsWith('-')) {
      showWarningSnackbar('Prefix cannot start with 0, /, or -');
      return false;
    }
    return true;
  };
  const handleNewSetting = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    if (value.length > 9) {
      // showWarningSnackbar("Prefix shouldn't be starting with '0,/,-'")
      return;
    } else if (name === 'nextinvoicenumber') {
      if (/^\d*$/.test(value)) {
        setSettingObj({
          ...settingObj,
          [name]: value,
        });
      } else {
        showWarningSnackbar('Please provide only digits');
      }
    } else {
      setSettingObj({
        ...settingObj,
        [name]: value,
      });
    }
  };
  const saveChanges = async () => {
    if (settingObj.nextinvoicenumber === '') {
      showWarningSnackbar('Please enter the start number');
    } else if (
      editData.id &&
      editData.prefix === settingObj.prefix &&
      editData.suffix === settingObj.suffix &&
      editData.nextinvoicenumber !== settingObj.nextinvoicenumber
    ) {
      setBackdropOpen(true);
      const salesSettingsData = {
        id: editData.id,
        companyid: getCompany?.companyid,
        entrytypecd: editData.entrytypecd,
        nextinvoicenumber: Number(settingObj.nextinvoicenumber),
        financialyearid: fyid,
        prefix: settingObj.prefix ? settingObj.prefix : '',
        serialisused: editData.serialisused,
        startinvoicenumber: editData.serialisused == 1 ? editData.startinvoicenumber : Number(settingObj.nextinvoicenumber),
        suffix: settingObj.suffix ? settingObj.suffix : '',
        serialnumber:
          settingObj.prefix && settingObj.suffix
            ? `${settingObj.prefix.trim()}/${settingObj.suffix.trim()}`
            : settingObj.suffix
            ? settingObj.suffix.trim()
            : settingObj.prefix
            ? settingObj.prefix.trim()
            : '',
        serialisactive: editData.serialisactive,
        serialflag: editData.serialflag,
      };
      try {
        const resSalesSettings = await API.graphql(
          graphqlOperation(updateNumberTracker, {
            updateNumberTrackerInput: salesSettingsData,
          })
        );
        console.log(resSalesSettings.data, 'resSalesSettings.data');
        onChange(resSalesSettings.data);
        if (resSalesSettings.data.updateNumberTracker.statuscode === 'ERROR') {
          showWarningSnackbar(resSalesSettings.data.updateNumberTracker.statusmessage);
        } else {
          invalidateAllVoucherSerialNumbers();
          showSuccessSnackbar('Setting has been modified');
          setSetting((prevData) =>
            prevData.map((item) =>
              item.id === editData.id
                ? {
                    ...item,
                    prefix: settingObj.prefix,
                    suffix: settingObj.suffix,
                    nextinvoicenumber: settingObj.nextinvoicenumber,
                  }
                : item
            )
          );
          setEditData('');
          setNewSetting(false);
          setBackdropOpen(false);
        }
      } catch (err) {
        console.log(err, 'errrr');
        const rawMessage = err.errors[0].message.split('RDSHttp:')[1];
        const parsedMessage = JSON.parse(rawMessage).message;
        const errMessage = parsedMessage.split(';')[0].replace(/^ERROR:\s*/, '');
        showWarningSnackbar(errMessage);
        prefixref.current.focus();
      }
    } else if (
      editData.id &&
      editData.prefix === settingObj.prefix &&
      editData.suffix === settingObj.suffix &&
      editData.nextinvoicenumber === settingObj.nextinvoicenumber
    ) {
      setEditData('');
    } else {
      const settingList = [...setting];
      const settingListExceptCurrent = settingList.filter((s) => s.id != editData.id);
      const isMatchFound = settingListExceptCurrent.some((set) => {
        if (
          settingObj.prefix?.trim() === '' &&
          settingObj.suffix?.trim() === '' &&
          set.prefix === settingObj.prefix &&
          set.suffix === settingObj.prefix
        ) {
          return true;
        }
        return settingObj?.prefix?.trim() !== '' && settingObj?.prefix?.trim().toUpperCase() === set?.prefix?.trim().toUpperCase()
          ? settingObj.suffix?.trim().toUpperCase() === set.suffix?.trim().toUpperCase() && true
          : settingObj?.prefix?.trim().toUpperCase() === '' &&
            settingObj?.suffix?.trim().toUpperCase() !== '' &&
            settingObj?.suffix?.trim().toUpperCase() === set?.suffix?.trim().toUpperCase() &&
            set.prefix === ''
          ? true
          : false;
      });
      const isMatchFound2 = settingListExceptCurrent.some((set) => {
        if (settingObj.prefix === '' && settingObj.suffix === '' && set.prefix === settingObj.prefix && set.suffix === settingObj.prefix) {
          return true;
        }
        return settingObj?.suffix?.trim() !== '' && settingObj?.suffix?.trim().toUpperCase() === set?.suffix?.trim().toUpperCase()
          ? settingObj.prefix?.trim().toUpperCase() === set.prefix?.trim().toUpperCase() && true
          : settingObj?.suffix?.trim().toUpperCase() === '' &&
            settingObj?.prefix?.trim().toUpperCase() !== '' &&
            settingObj?.prefix?.trim().toUpperCase() === set?.prefix?.trim().toUpperCase() &&
            set.suffix === ''
          ? true
          : false;
      });
      if (isMatchFound === true && isMatchFound2 === true) {
        showErrorSnackbar(`This ${label} setting already exists`);
      } else if (editData.id) {
        setBackdropOpen(true);
        const salesSettingsData = {
          id: editData.id,
          companyid: getCompany?.companyid,
          entrytypecd: editData.entrytypecd,
          nextinvoicenumber: Number(settingObj.nextinvoicenumber),
          financialyearid: fyid,
          prefix: settingObj.prefix ? settingObj.prefix : '',
          serialisused: editData.serialisused,
          suffix: settingObj.suffix ? settingObj.suffix : '',
          serialnumber:
            settingObj.prefix && settingObj.suffix
              ? `${settingObj.prefix.trim()}/${settingObj.suffix.trim()}`
              : settingObj.suffix
              ? settingObj.suffix.trim()
              : settingObj.prefix
              ? settingObj.prefix.trim()
              : '',
          serialisactive: editData.serialisactive,
          serialflag: editData.serialflag,
          startinvoicenumber: editData.serialisused == 1 ? editData.startinvoicenumber : Number(settingObj.nextinvoicenumber),
        };
        try {
          const resSalesSettings = await API.graphql(
            graphqlOperation(updateNumberTracker, {
              updateNumberTrackerInput: salesSettingsData,
            })
          );
          if (resSalesSettings.data.updateNumberTracker.statuscode === 'SUCCESS') {
            showWarningSnackbar(resSalesSettings.data.updateNumberTracker.statusmessage);

            invalidateAllVoucherSerialNumbers();
            showSuccessSnackbar('Setting has been modified');
            onChange(resSalesSettings.data);
            setSetting((prevData) =>
              prevData.map((item) =>
                item.id === editData.id
                  ? {
                      ...item,
                      prefix: settingObj.prefix,
                      suffix: settingObj.suffix,
                      nextinvoicenumber: settingObj.nextinvoicenumber,
                    }
                  : item
              )
            );
            setEditData('');
            setNewSetting(false);
            setBackdropOpen(false);
          }
        } catch (err) {
          const rawMessage = err.errors[0].message.split('RDSHttp:')[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          showWarningSnackbar(parsedMessage);
          prefixref.current.focus();
        }
      }
      // }
      else {
        setBackdropOpen(true);
        const salesSettingsData = {
          entrytypecd: type,
          companyid: getCompany?.companyid,
          nextinvoicenumber: Number(settingObj.nextinvoicenumber),
          prefix: settingObj.prefix ? settingObj.prefix.trim() : '',
          suffix: settingObj.suffix ? settingObj.suffix.trim() : '',
          financialyearid: fyid,
          serialisused: 0,
          serialnumber:
            settingObj.prefix && settingObj.suffix
              ? `${settingObj.prefix.trim()}/${settingObj.suffix.trim()}`
              : settingObj.suffix
              ? settingObj.suffix.trim()
              : settingObj.prefix
              ? settingObj.prefix.trim()
              : '',
          serialisactive: 1,
          serialflag: 0,
          startinvoicenumber: Number(settingObj.nextinvoicenumber),
        };
        const resSalesSettings = await API.graphql(
          graphqlOperation(createNumberTracker, {
            createNumberTrackerInput: [salesSettingsData],
          })
        );
        onChange(resSalesSettings.data);
        if (resSalesSettings.data.createNumberTracker[0].statuscode === 'ERROR') {
          showWarningSnackbar(resSalesSettings.data.createNumberTracker[0].statusmessage);
          prefixref.current.focus();
        } else {
          showSuccessSnackbar('Setting added');
          invalidateAllVoucherSerialNumbers();
          listSetting();
          setNewSetting(false);
          setSettingObj(addNewSetting);
        }
      }
    }

    setBackdropOpen(false);
  };
  const handleEditSetting = (data) => {
    setEditData(data);
    // setNewSetting(false);
    const addNewSetting = {
      prefix: data.prefix,
      nextinvoicenumber: data.nextinvoicenumber,
      suffix: data.suffix,
    };
    setSettingObj(addNewSetting);
  };
  const handleStatus = async (set) => {
    setActiveValueModal(true);
    console.log(set, 'set');
    const salesSettingsData = {
      id: Number(set.id),
      companyid: getCompany?.companyid,
      entrytypecd: set?.entrytypecd,
      serialisused: set?.serialisused,
      nextinvoicenumber: Number(set?.nextinvoicenumber),
      financialyearid: set?.financialyearid,
      prefix: set?.prefix ? set?.prefix : '',
      suffix: set.suffix ? set?.suffix : '',
      serialnumber:
        set.prefix && set.suffix
          ? `${set.prefix.trim()}/${set.suffix.trim()}`
          : set.suffix
          ? set.suffix.trim()
          : set.prefix
          ? set.prefix.trim()
          : '',
      serialisactive: set?.serialisactive === 0 ? 1 : 0,
      serialflag: set?.serialflag,
      startinvoicenumber: set?.startinvoicenumber ? set?.startinvoicenumber : Number(set?.nextinvoicenumber),
    };

    const resSalesSettings = await API.graphql(
      graphqlOperation(updateNumberTracker, {
        updateNumberTrackerInput: salesSettingsData,
      })
    );
    onChange(resSalesSettings.data);
    setSetting(
      setting.map((itemm) =>
        itemm.id == set.id
          ? {
              ...itemm,
              serialisactive: set?.serialisactive === 0 ? 1 : 0,
            }
          : itemm
      )
    );
    invalidateAllVoucherSerialNumbers();
    const str = set?.serialisactive === 0 ? 'Active' : 'Inactive';
    showSuccessSnackbar('Settings has been updated to ' + str);
  };
  const modeChange = async (mode) => {
    try {
      setBackdropOpen(true);
      if (mode === 'MANUAL') {
        // setNewSetting(false);
        const deleteAllVoucher = await API.graphql(
          graphqlOperation(deleteNumberTrackerByType, {
            deleteNumberTrackerByTypeInput: {
              entrytypecd: type,
              mode,
            },
          })
        );
        const itemSettingsData = {
          entrytypecd: type,
          serialnumber: '',
          serialisactive: 0,
          serialisused: 0,
          companyid: getCompany?.companyid,
          financialyearid: fyid,
          nextinvoicenumber: -1,
          prefix: '',
          suffix: '',
          serialflag: 0,
          startinvoicenumber: 0,
        };
        const resItemSettings = await API.graphql(
          graphqlOperation(createNumberTracker, {
            createNumberTrackerInput: [itemSettingsData],
          })
        );
        setMode(mode);
        onChange(resItemSettings.data);
        invalidateAllVoucherSerialNumbers();
        showSuccessSnackbar('settings has been switched to Manual Successfully');
        setModeModal({ type: false, val: '' });
      }

      if (mode === 'AUTO') {
        const deleteAllVoucher = await API.graphql(
          graphqlOperation(deleteNumberTrackerByType, {
            deleteNumberTrackerByTypeInput: {
              entrytypecd: type,
              mode,
            },
          })
        );
        let data = [];
        setting.map((ele) => {
          let dat;
          dat = {
            entrytypecd: type,
            serialnumber: ele.prefix && ele.suffix ? `${ele.prefix}/${ele.suffix}` : ele.prefix ? ele.prefix : ele.suffix,
            serialisactive: ele.serialisactive,
            serialisused: ele?.serialisused,
            companyid: getCompany?.companyid,
            financialyearid: fyid,
            nextinvoicenumber: ele.nextinvoicenumber,
            prefix: ele.prefix,
            suffix: ele.suffix,
            serialflag: ele.serialflag,
            startinvoicenumber: ele?.startinvoicenumber ? ele?.startinvoicenumber : ele.nextinvoicenumber,
          };
          data.push(dat);
        });
        const resItemSettings = await API.graphql(
          graphqlOperation(createNumberTracker, {
            createNumberTrackerInput: data,
          })
        );
        setMode(mode);
        onChange(resItemSettings.data);
        invalidateAllVoucherSerialNumbers();
        listSetting();
        showSuccessSnackbar('settings has been switched to Autogenerated Successfully');
        setModeModal({ type: false, val: '' });
      }
    } catch (error) {
      console.error('Error changing mode:', error);
      showErrorSnackbar('Failed to change mode. Please try again.');
    } finally {
      setBackdropOpen(false);
    }
  };
  console.log(mode, 'mode');
  const ids = [
    'partyCreationModal',
    'PriceModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'addCategory',
    'addUnit',
    'deleteCategory',
    'AddItemsAccountModal',
    'AddHSNModal',
    'CreatePriceType',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveModalShortcut(() => {
    if (!anyElementExists() && open === true) {
      saveChanges();
    }
  });

  return (
    <Box id={open ? 'SettingsModal' : ''}>
      <Modal
        //   id={open ? "voucherSettings" : ""}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // style={{ width: "400px" }}
        //   closeAfterTransition
        onClose={handleClose}
        //   BackdropProps={{ onClick: (e) => e.stopPropagation() }}
      >
        <Fade in={open}>
          <Paper style={{ boxShadow: 'none' }} sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '10px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {`${label} settings`}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ margin: 2 }}>
                <RadioGroup
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'row' },
                    border: '2px solid transparent',
                    pl: '5px',
                    '&:focus-within': {
                      borderColor: 'primary.main', // Highlight border color
                      borderWidth: '2px',
                      borderStyle: 'solid',
                      borderRadius: '4px',
                    },
                  }}
                  //   onKeyDown={(event) => {
                  //     if (event.key === "Enter") {
                  //       event.stopPropagation();
                  //       event.preventDefault();
                  //       setSettingsFlag(settingsFlag == "2" ? "1" : "2");
                  //     }
                  //   }}
                  onChange={(e) => {
                    if (newSetting === false && editData === '') {
                      // setMode(e.target.value);
                      setModeModal({ type: true, val: e.target.value });
                    } else if (newSetting === true) {
                      showWarningSnackbar('Please save or cancel the new series');
                    } else {
                      showWarningSnackbar('Please update or cancel the series');
                    }
                  }}
                  name="VoucherNumber"
                  value={mode}
                >
                  <FormControlLabel
                    sx={{
                      '.css-ywaoe2-MuiFormControlLabel-root .MuiFormControlLabel-label': {
                        fontSize: '10px',
                      },
                    }}
                    name="VoucherNumber"
                    value="MANUAL"
                    control={<Radio size="small" disableRipple />}
                    label="Manual entry"
                  />
                  <FormControlLabel
                    sx={{
                      '.css-ywaoe2-MuiFormControlLabel-root .MuiFormControlLabel-label': {
                        fontSize: '10px',
                      },
                    }}
                    name="VoucherNumber"
                    value="AUTO"
                    control={<Radio size="small" />}
                    label="Auto generated"
                  />
                </RadioGroup>
              </Box>
            </Box>
            <Box sx={{ padding: '10px', m: '10px' }}>
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 400,
                  minWidth: '100%',
                  '&::-webkit-scrollbar': {
                    width: '0.4em',
                    height: '0.4em',
                  },
                  '&:hover::-webkit-scrollbar': {
                    width: '0.6em',
                    height: '0.4em',
                  },
                  '.MuiTableCell-root': {
                    padding: '8px 5px',
                  },
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {heading.map((head) => (
                        <TableCell
                          style={{ color: '#fff' }}
                          sx={{
                            backgroundColor: 'primary.main',
                            color: '#FFF',
                            lineHeight: '1rem',
                            textAlign: 'center',
                          }}
                        >
                          {head}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      '.MuiTableCell-root': {
                        backgroundColor: 'transparent !important',
                      },
                    }}
                  >
                    {newSetting === true ? (
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell
                          sx={{
                            width: '130px',
                            // textAlign: 'center',
                            border: 'none !important',
                          }}
                        >
                          <TextField
                            size="small"
                            label="Prefix"
                            name="prefix"
                            inputRef={prefixref}
                            value={settingObj.prefix}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === '' || (INVOICE_REGEX.test(value) && validatePrefix(value))) {
                                handleNewSetting(e);
                              } else {
                                setSettingObj((prev) => ({
                                  ...prev,
                                  prefix: e.target.value === '' ? '' : prev.prefix,
                                }));
                                if (!validatePrefix(value)) {
                                  showWarningSnackbar('Prefix cannot start with 0,/,-');
                                  // Error message already shown in validatePrefix function
                                } else {
                                  showWarningSnackbar('Prefix contains invalid characters');
                                }
                              }
                            }}
                            inputProps={{ maxLength: 10 }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            // width: '150px',
                            // textAlign: 'center',
                            border: 'none !important',
                          }}
                        >
                          <TextField
                            size="small"
                            sx={{
                              width: 130, // or 150 depending on layout
                            }}
                            label="Start Number"
                            name="nextinvoicenumber"
                            value={settingObj.nextinvoicenumber}
                            onChange={handleNewSetting}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            width: '130px',
                            textAlign: 'center',
                            border: 'none !important',
                          }}
                        >
                          <TextField
                            size="small"
                            label="Suffix"
                            name="suffix"
                            value={settingObj.suffix}
                            onChange={(e) => {
                              if (INVOICE_REGEX1.test(e.target.value)) {
                                handleNewSetting(e);
                              } else {
                                setSettingObj((prev) => ({
                                  ...prev,
                                  suffix: e.target.value === '' ? '' : prev.suffix,
                                }));
                                showWarningSnackbar('Suffix contains invalid characters');
                              }
                            }}
                            //  onChange={handleNewSetting}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            width: '180px',
                            textAlign: 'center',
                            border: 'none !important',
                          }}
                        >
                          {settingObj.prefix + settingObj.nextinvoicenumber + settingObj.suffix}
                        </TableCell>
                        <TableCell sx={{ border: 'none !important' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <Box>
                              <IconButton
                                sx={{
                                  margin: '0px 2px',
                                  padding: '5px',
                                  backgroundColor: '#fbc7c78c',
                                  '&:focus': {
                                    backgroundColor: '#d5d5d5',
                                  },
                                }}
                                onClick={saveChanges}
                              >
                                <DoneIcon
                                  sx={{
                                    fontSize: `15px`,
                                    color: '#6096d9',
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                sx={{
                                  margin: '0px 2px',
                                  padding: '5px',
                                  backgroundColor: '#fbc7c78c',
                                  '&:focus': {
                                    backgroundColor: '#d5d5d5',
                                  },
                                }}
                                // ref={buttonRefclose}
                                onClick={() => setNewSetting(false)}
                              >
                                <CloseIcon
                                  sx={{
                                    fontSize: '15px',
                                    color: '#eb6a6a',
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                    {mode === 'AUTO' ? (
                      setting && setting.length > 0 ? (
                        setting.map((set, index) => (
                          <TableRow hover role="checkbox">
                            <TableCell sx={{ border: 'none !important' }}>{index + 1}</TableCell>
                            <TableCell
                              sx={{
                                minWidth: '130px',
                                textAlign: 'center',
                                border: 'none !important',
                              }}
                              className={set.serialisactive === 0 ? 'inactive-row' : ''}
                            >
                              {editData.id === set.id && deleteModal === false && activeValueModal === false ? (
                                <TextField
                                  size="small"
                                  label="Prefix"
                                  name="prefix"
                                  inputRef={prefixref}
                                  value={settingObj.prefix}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || (INVOICE_REGEX.test(value) && validatePrefix(value))) {
                                      handleNewSetting(e);
                                    } else {
                                      setSettingObj((prev) => ({
                                        ...prev,
                                        prefix: e.target.value === '' ? '' : prev.prefix,
                                      }));
                                      if (!validatePrefix(value)) {
                                        // Error message already shown in validatePrefix function
                                        showWarningSnackbar('Prefix cannot start with 0,/,-');
                                      } else {
                                        showWarningSnackbar('Please provide valid value');
                                      }
                                    }
                                  }}
                                  inputProps={{ maxLength: 10 }}
                                />
                              ) : set.prefix ? (
                                set.prefix
                              ) : (
                                ''
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: 'center',
                                border: 'none !important',
                              }}
                              className={set.serialisactive === 0 ? 'inactive-row' : ''}
                            >
                              {editData.id === set.id && deleteModal === false && activeValueModal === false ? (
                                <TextField
                                  size="small"
                                  label="Start Number"
                                  InputLabelProps={{
                                    shrink: settingObj.nextinvoicenumber !== '' ? true : false,
                                  }}
                                  sx={{
                                    width: 130, // or 150 depending on layout
                                  }}
                                  onChange={handleNewSetting}
                                  name="nextinvoicenumber"
                                  value={settingObj.nextinvoicenumber}
                                />
                              ) : (
                                set.nextinvoicenumber
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                minWidth: '130px',
                                textAlign: 'center',
                                border: 'none !important',
                              }}
                              className={set.serialisactive === 0 ? 'inactive-row' : ''}
                            >
                              {editData.id === set.id && deleteModal === false && activeValueModal === false ? (
                                <TextField
                                  size="small"
                                  label="Suffix"
                                  name="suffix"
                                  value={settingObj.suffix}
                                  onChange={(e) => {
                                    if (INVOICE_REGEX1.test(e.target.value)) {
                                      handleNewSetting(e);
                                    } else {
                                      setSettingObj((prev) => ({
                                        ...prev,
                                        suffix: e.target.value === '' ? '' : prev.suffix,
                                      }));
                                      showWarningSnackbar('Please provide valid value');
                                    }
                                  }}
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                      editDoneRef.current.focus();
                                    }
                                  }}
                                />
                              ) : set.suffix ? (
                                set.suffix
                              ) : (
                                ''
                              )}
                            </TableCell>

                            <TableCell
                              sx={{
                                minWidth: '180px',
                                textAlign: 'center',
                                border: 'none !important',
                              }}
                              className={set.serialisactive === 0 ? 'inactive-row' : ''}
                            >
                              {editData.id === set.id && deleteModal === false && activeValueModal === false
                                ? settingObj.prefix + settingObj.nextinvoicenumber + settingObj.suffix
                                : (set.prefix ? set.prefix : '') + set.nextinvoicenumber + (set.suffix ? set.suffix : '')}
                            </TableCell>
                            <TableCell
                              sx={{
                                minWidth: '120px',
                                textAlign: 'center',
                                border: 'none !important',
                              }}
                              className={set.serialisactive === 0 ? 'inactive-row' : ''}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                {editData.id === set.id && deleteModal === false && activeValueModal === false ? (
                                  <Box>
                                    <IconButton
                                      disableRipple={false}
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#fbc7c78c',
                                        '&:focus': {
                                          backgroundColor: '#d5d5d5',
                                        },
                                      }}
                                      ref={editDoneRef}
                                      onClick={saveChanges}
                                    >
                                      <DoneIcon
                                        sx={{
                                          fontSize: `15px`,
                                          color: '#6096d9',
                                        }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#fbc7c78c',
                                        '&:focus': {
                                          backgroundColor: '#d5d5d5',
                                        },
                                      }}
                                      // ref={buttonRefclose}
                                      onClick={() => {
                                        setSettingObj(addNewSetting);
                                        setEditData('');
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: '15px',
                                          color: '#eb6a6a',
                                        }}
                                      />
                                    </IconButton>
                                  </Box>
                                ) : (
                                  <Box>
                                    <Tooltip
                                      title={set.serialisactive === 1 ? 'Mark as In-Active' : 'Mark as Active'}
                                      placement="left"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        onClick={() => {
                                          if (newSetting === false && editData === '') {
                                            if (set?.serialflag == 1 || set?.serialflag == 2) {
                                              showWarningSnackbar('Default settings cannot be deactivated');
                                            } else {
                                              setActiveValueModal(true);
                                              setEditData(set);
                                            }
                                          } else if (newSetting === true) {
                                            showWarningSnackbar('Please save or cancel the new series');
                                          } else {
                                            showWarningSnackbar('Please update or cancel the series');
                                          }
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#FEF3C7',
                                        }}
                                      >
                                        {set.serialisactive == 1 ? (
                                          <DirectionsRun
                                            sx={{
                                              fontSize: '15px',
                                              color: '#E29819',
                                            }}
                                          />
                                        ) : (
                                          <Accessibility
                                            sx={{
                                              fontSize: '15px',
                                              color: '#E29819',
                                            }}
                                          />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={set.serialisactive === 0 ? '' : 'Edit'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        disableRipple={false}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: set.serialisactive === 0 ? '' : '#D0EFFF',
                                        }}
                                        onClick={() => {
                                          if (newSetting === false && editData === '') {
                                            if (set?.serialisactive == 0) {
                                              showWarningSnackbar("You can't modify the inactive setting");
                                            } else {
                                              handleEditSetting(set);
                                            }
                                          } else if (newSetting === true) {
                                            showWarningSnackbar('Please save or cancel the new series');
                                          } else {
                                            showWarningSnackbar('Please update or cancel the series');
                                          }
                                        }}
                                        // disabled={set.serialisactive === 0}
                                      >
                                        <EditIcon
                                          sx={{
                                            fontSize: '15px',
                                            color: '#6096d9',
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete" placement="left" disableInteractive arrow>
                                      <IconButton
                                        disableRipple={false}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: set?.serialisused == 1 ? '#fbc7c7' : '#fbc7c7',
                                        }}
                                        onClick={() => {
                                          if (newSetting === false && editData === '') {
                                            if (set?.serialflag == 1 || set?.serialflag == 2) {
                                              showWarningSnackbar('Default settings cannot be deleted');
                                            } else if (set?.serialisused == 1) {
                                              showWarningSnackbar(
                                                "You can't delete the setting because there are relevant transactions that exist"
                                              );
                                            } else {
                                              setDeleteModal(true);
                                              setEditData(set);
                                            }
                                          } else if (newSetting === true) {
                                            showWarningSnackbar('Please save or cancel the new series');
                                          } else {
                                            showWarningSnackbar('Please update or cancel the series');
                                          }
                                        }}
                                      >
                                        <DeleteIcon
                                          sx={{
                                            fontSize: '15px',
                                            color: '#eb6a6a',
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                )}
                              </Box>
                            </TableCell>
                            {/* )} */}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell>No Items Found</TableCell>
                        </TableRow>
                      )
                    ) : (
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell
                          sx={{
                            minWidth: '130px',
                            textAlign: 'center',
                          }}
                        ></TableCell>
                        <TableCell
                          sx={{
                            minWidth: '130px',
                            textAlign: 'center',
                          }}
                        ></TableCell>
                        <TableCell
                          sx={{
                            minWidth: '180px',
                            textAlign: 'center',
                          }}
                        ></TableCell>
                        <TableCell
                          sx={{
                            minWidth: '130px',
                            textAlign: 'center',
                          }}
                        ></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    dispaly: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    disableRipple={false}
                    disableElevation
                    size="small"
                    variant="text"
                    onClick={() => {
                      setEditData('');
                      setSettingObj(addNewSetting);
                      setNewSetting(true);
                    }}
                    disabled={mode === 'AUTO' && !editData && newSetting === false ? false : true}
                    startIcon={<AddBox />}
                    sx={{
                      fontSize: '14px',
                      marginTop: '15px',
                      color: '#5c5cd2',
                      fontStyle: 'italic',
                      fontWeight: 'bold',
                    }}
                  >
                    Add new series
                  </Button>
                </Box>
              </Box>
            </Box>
            {activeValueModal && (
              <ListingActive
                text={'settings'} //need to give text that need to show in the modal
                open={activeValueModal}
                editData={editData}
                setOpen={setActiveValueModal}
                setFn={() => {
                  setEditData('');
                  setActiveValueModal(false);
                  // setNewSetting(false);
                }}
                action={() => {
                  handleStatus(editData);
                  setEditData('');
                  setActiveValueModal(false);
                }}
              />
            )}
            {deleteModal && (
              <DeleteModal
                open={deleteModal}
                setOpen={setDeleteModal}
                setFn={() => {
                  setEditData('');
                  setDeleteModal(false);
                  // setNewSetting(false);
                }}
                func={() => {
                  handleDelete(editData.id);
                  setEditData('');
                  setDeleteModal(false);
                }}
                text={'Setting'}
              />
            )}

            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Paper>
        </Fade>
      </Modal>
      {modeModal && (
        <DeleteModal
          open={modeModal.type}
          loading={backdropOpen}
          text2="change"
          setFn={() => setModeModal({ type: false, val: '' })}
          func={() => modeChange(modeModal.val)}
          text="mode"
        />
      )}
    </Box>
  );
};

export default NewVoucherSettingsModal;
